import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { helper } from 'src/environments/helper';
import { finalize } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { ModuleService } from '../module.service';
import { IAdvancedEditModulPayload, IEditModulPayload, IModul, IModulForm, IProgramLocatieModul, TimeData } from '../module.interface';
import { ModuleTipuriProgramActiveService } from '../../module-tipuri-program-active/module-tipuri-program-active.service';
import { ModuleLocatiiActiveService } from '../../module-locatii-active/module-locatii-active.service';
import { Generic } from 'src/app/interfaces/generic.interface';

@Component({
    selector: 'app-programare-modul',
    templateUrl: './programare-modul.component.html',
    styleUrls: ['./programare-modul.component.scss']
})
export class ProgramareModulComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;
    moduleId!: number;
    moduleName!: string;
    durataProgramare!: number;
    durataIntervalBlocare!: number;

    locatii: Generic[] = [];
    locatiiActiveModulIds: number[] = [];
    locatiiRows: { id_locatie: number; name: string; checked: boolean; }[] = [];

    tipuriProgramModul: Generic[] = [];
    timeData: TimeData[] = [];

    durataOptions: { name: string; value: number }[] = [
        { name: '--Alegeți--', value: -1 },
        { name: '5 minute', value: 5 },
        { name: '10 minute', value: 10 },
        { name: '15 minute', value: 15 },
        { name: '20 minute', value: 20 },
        { name: '25 minute', value: 25 },
        { name: '30 minute', value: 30 },
        { name: '35 minute', value: 35 },
        { name: '40 minute', value: 40 },
        { name: '45 minute', value: 45 },
        { name: '50 minute', value: 50 },
        { name: '55 minute', value: 55 },
        { name: '60 minute', value: 60 },
    ]

    selectedHour: string = '08';
    possibleHours = ['08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18'];

    selectedMinute: string = '00';
    possibleMinutes = ['00'];

    selectedDayID = 1;
    daysOfWeek = [
        {
            id_day: 1,
            day: "Luni",
        },
        {
            id_day: 2,
            day: "Marți",
        },
        {
            id_day: 3,
            day: "Miercuri",
        },
        {
            id_day: 4,
            day: "Joi",
        },
        {
            id_day: 5,
            day: "Vineri",
        },
        {
            id_day: 6,
            day: "Sâmbătă",
        },
        {
            id_day: 0,
            day: "Duminică",
        },
    ];

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            moduleData: IModul;
            locatii: Generic[];
        },
        private dialogRef: MatDialogRef<ProgramareModulComponent>,
        private moduleService: ModuleService,
        private moduleTipuriProgramActiveService: ModuleTipuriProgramActiveService,
        private moduleLocatiiActiveService: ModuleLocatiiActiveService,
        private notificationService: NotificationService,
    ) {
        this.moduleId = data.moduleData.id;
        this.moduleName = data.moduleData.name;
        this.durataProgramare = data.moduleData.durata_programare;
        this.durataIntervalBlocare = data.moduleData.durata_interval_blocare;
        this.locatii = data.locatii;

        this.generateMinuteProgramare(this.durataProgramare)
    }

    ngOnInit(): void {
        this.loadProgramTypesModul(this.moduleId);
        this.loadLocatiiActiveModul(this.moduleId);
        this.loadProgramLocatiiModul(this.moduleId);
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    loadLocatiiActiveModul(id_modul: number) {
        this.isLoading = true;
        this.moduleLocatiiActiveService
            .findByModule(id_modul)
            .pipe(
                finalize(() => { this.isLoading = false; })
            )
            .subscribe((results) => {
                this.locatiiActiveModulIds = results.map(item => item.id_locatie);
                this.locatiiRows = this.locatii.map((item: Generic) => ({
                    id_locatie: item.id,
                    name: item.name,
                    checked: this.locatiiActiveModulIds.includes(item.id),
                }))

                // console.log('locatiiRows', this.locatiiRows);
            })
    }

    loadProgramTypesModul(id_modul: number) {
        this.isLoading = true;
        this.moduleTipuriProgramActiveService
            .findByModule(id_modul)
            .pipe(
                finalize(() => { this.isLoading = false; })
            )
            .subscribe((results) => {
                this.tipuriProgramModul = results;

                // console.log('tipuriProgramModul', this.tipuriProgramModul);
            })
    }

    loadProgramLocatiiModul(id_modul: number) {
        this.isLoading = true;
        this.moduleService
            .listProgramLocatiiModul(id_modul)
            .pipe(
                finalize(() => { this.isLoading = false; })
            )
            .subscribe((results) => {
                this.timeData = results.map(program => {
                    return {
                        hour: program.time_from.slice(0, 2),
                        minute: program.time_from.slice(3, 5),
                        day: program.day_of_week,
                        id_locatie: program.id_locatie,
                        id_program_type: program.id_program_type,
                        id_locatie_program: program.id,
                    }
                });

                // console.log('timeData', this.timeData);
            })
    }

    generateMinuteProgramare(durataProgramare: number) {
        const generatedMinute: number[] = []

        for (let currentValue = 0; currentValue < 60; currentValue += durataProgramare) {
            generatedMinute.push(currentValue);
        }

        this.possibleMinutes = generatedMinute.map(minut => {
            if (minut < 10) {
                return '0' + minut.toString()
            } else {
                return minut.toString()
            }
        })
    }

    selectDay(id_day: number) {
        this.selectedDayID = id_day;
    }

    addTime(id_locatie: number, id_program_type: number) {
        const newTime = {
            hour: this.selectedHour,
            minute: this.selectedMinute,
            day: this.selectedDayID,
            id_locatie: id_locatie,
            id_program_type: id_program_type,
            added: true,
        }

        const existingTime = this.timeData.find(time => {
            if (time.hour === newTime.hour &&
                time.minute === newTime.minute &&
                time.day === newTime.day &&
                time.id_locatie === newTime.id_locatie &&
                time.id_program_type === newTime.id_program_type
            ) {
                return true
            } else {
                return false
            }
        })

        if (!existingTime) {
            this.timeData.push(newTime);

            this.increaseTime();
        } else if (existingTime && existingTime.deleted === true) {
            existingTime.deleted = false;

            this.increaseTime();
        } else {
            this.notificationService.warningSwal(
                this.errorTitle,
                'Ora și minutul alese sunt deja existente.',
                this.errorIcon
            );
        }

        // console.log('timeData', this.timeData);
    }

    increaseTime() {
        const durataProgramare = this.data.moduleData.durata_programare;
        let newMinute = parseInt(this.selectedMinute, 10) + durataProgramare;
        let newHour = parseInt(this.selectedHour, 10);

        if (newMinute >= 60) {
            newMinute = 0;
            newHour += 1;

            if (newHour === 19) {
                newHour = 8;
            }
        }

        this.selectedMinute = newMinute < 10 ? '0' + newMinute.toString() : newMinute.toString();
        this.selectedHour = newHour < 10 ? '0' + newHour.toString() : newHour.toString();
    }

    removeTime(timeIndex: number) {
        if (this.timeData[timeIndex].added === true) {
            // Remove time that was just added, not yet saved in the BE
            this.timeData.splice(timeIndex, 1);
        } else {
            // Remove previously added time, time from the BE
            this.timeData[timeIndex].deleted = true;
        }

        // console.log('timeData', this.timeData);
    }

    updateTimesModul() {
        this.isLoading = true;

        const payload: IAdvancedEditModulPayload = {
            locations: this.locatiiRows,
            timeData: this.timeData,
            id_module: this.moduleId,
            durata_programare: this.durataProgramare,
            durata_interval_blocare: this.durataIntervalBlocare,
        };

        this.moduleService
            .advancedEditModul(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
